import api from './api';

export const getUserCompaniesApi = (params) => api().get('/user-companies', { params });
export const addNewUserCompanyApi = (data) => api().post('/user-companies', data);
export const deleteUserCompaniesApi = (params) => api().delete(`/user-companies/${params.id}`, { params });
export const updateUserCompaniesApi = (params) => api().put(`/user-companies/${params.id}`, params.values);
